import { Calendar, Select, Skeleton } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { timeZoneOptions } from "../../services/util";
import "./style.css";

const { Option } = Select;

function Schedule() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");

    const [calendarData, setCalendarData] = useState([]);
    const [formData, setFormData] = useState({
        staff_id,
        time_zone: "PST",
    });

    const { status, data, refetch } = useQuery(
        "schedule",
        async () => {
            return await HTTP("/teams/getCalenderDetail", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        refetch();
    }, []);

    useEffect(() => {
        refetch();
    }, [formData]);

    useEffect(() => {
        if (status === "success") {
            setCalendarData(data.data);
        }
    }, [status, data]);

    const getListData = (value) => {
        let listData = [];

        const event = calendarData.find((e) => {
            return (
                moment(Object.keys(e)[0]).date() === value.date() &&
                moment(Object.keys(e)[0]).month() === value.month()
            );
        });

        if (event) {
            [listData] = Object.values(event);
        }

        return listData;
    };

    const dateCellRender = (value) => {
        const listData = getListData(value);

        const isToday =
            value.date() === moment().date() &&
            value.month() === moment().month();

        return (
            <div className={`shift-card ${isToday ? "today" : ""}`}>
                <div className="shift-date">{value.date()}</div>

                {listData.map((item) => (
                    <div key={item.member_id} className="shift-item">
                        {item.name}
                        <br />
                        {item.timings_from} - {item.timings_to}
                    </div>
                ))}
            </div>
        );
    };

    function handleTimeZoneChange(value) {
        setFormData({ ...formData, time_zone: value });
    }

    return (
        <div className="calendar-container">
            {calendarData.length > 0 ? (
                <Calendar
                    className="bg-inherit"
                    mode="month"
                    dateFullCellRender={dateCellRender}
                    headerRender={() => (
                        <div className="calendar-header">
                            <div className="calendar-title">
                                Team Shift Schedule
                            </div>

                            <Select
                                style={{ width: 120 }}
                                onChange={handleTimeZoneChange}
                                defaultValue="PST"
                            >
                                {timeZoneOptions.map((e) => (
                                    <Option key={e} value={e}>
                                        {e}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    )}
                />
            ) : (
                <Skeleton active paragraph={{ rows: 15 }} />
            )}
        </div>
    );
}

export default Schedule;
